module.exports = __webpack_public_path__ + "static/img/Aions_GZ_Mar_8.8a029ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_GZ_Mar/Aions_GZ_Mar_8.png
// module id = JOLt
// module chunks = 19